import React from "react";
import { Container, Content, Title, Description, CloseButton } from "./styles";
import I176TextLogo from "assets/icons/I176TextLogo";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  onClose?: () => void;
};

const MessagePopup: React.FC<Props> = ({ title, onClose }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <I176TextLogo />
        <Title>{t("oneTimeModalTitle")}</Title>
        <Description>{title}</Description>
        {onClose && (
          <CloseButton onClick={onClose}>{t("actions.gotIt")}</CloseButton>
        )}
      </Content>
    </Container>
  );
};

export default MessagePopup;
